// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-report-view-pie-chart .fi-chart canvas {
  height: 150px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist-report/view/checklist-report-view-pie-chart/checklist-report-view-pie-chart.component.scss"],"names":[],"mappings":"AAEQ;EACI,aAAA;AADZ","sourcesContent":[".fi-checklist-report-view-pie-chart {\r\n    .fi-chart {\r\n        canvas {\r\n            height: 150px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
